import { MaxBrainAudience } from './audience.model';

export class AudienceCommand {
    name: string;
    parent: { id: string };
    type?: number;
    is_default?: boolean;

    constructor(tempAudience: MaxBrainAudience) {
        this.name = tempAudience.name;
        this.parent = { id: tempAudience.parent.id };

        if (tempAudience.type != null) {
            this.type = tempAudience.type;
        }

        if (tempAudience.isDefault != null) {
            this.is_default = tempAudience.isDefault;
        }
    }
}
